<template>
  <div
    class="fixed bottom-0 py-2.5 z-[9999] left-0 right-0 bg-white shadow-[0px_-6px_15.6px_0px_#00000017] border border-[#DDDDDD] rounded-t-md pt-0"
  >
    <div class="flex justify-between w-full px-4 border-b py-2.5">
      <TsTypography variant="sm"
        >{{ useTranslation("orderSummary", "Overzicht bestelling") }}
      </TsTypography>

      <TsTypography
        append-class="mb-0 flex items-center text-primary"
        weight="semibold"
        variant="sm"
        @click="order_summary_drawer_visible = true"
        >{{ props.totalProducts }} {{useTranslation("Checkout-moreThanOneProduct" , "Producten")}}
        <TsIcon name="iconamoon:arrow-up-2-duotone" size="20" />
      </TsTypography>
    </div>

    <Teleport to="body">
      <TsDrawer
        data-testid="checkout-order-summary-mobile-drawer"
        position="bottom"
        v-model:visible="order_summary_drawer_visible"
        append-class="text-left bg-white px-3 py-3 z-[9999]"
      >
        <div class="flex justify-between mb-3">
          <TsTypography append-class="mb-0" variant="sm"
            >{{ useTranslation("orderSummary", "Besteloverzicht") }}
          </TsTypography>
          <TsTypography
            append-class="mb-0 text-primary font-semibold flex"
            variant="sm"
            @click="order_summary_drawer_visible = false"
            >{{ props.totalProducts }}
            {{ useTranslation("products", "Producten") }}
            <TsIcon name="iconamoon:arrow-down-2-duotone" size="20" />
          </TsTypography>
        </div>
        <TsCardOrderSummary
          :data-testid="props.dataTestid + '-mobile'"
          :hideTitle="true"
          :total-products="props.totalProducts"
          :order-total="props.orderTotal"
          :sub-total="props.subTotal"
          :total-vat="props.totalVat"
          :total-exc-vat="props.totalExcVat"
          :is-free-ship="props.isFreeShip"
          :shipping-cost="props.shippingCost"
          :loading="props.loading"
        />

        <div class="flex gap-2.5 mt-6">
          <TsTypography append-class="leading-[18px] mb-0" variant="h3">
            {{ props.orderTotal }} <br />
            <span class="text-sm text-natural-grey">
              {{useTranslation('vat' , 'BTW')}} {{ props.totalExcVat }}</span
            >
          </TsTypography>
          <TsButton
            :disabled="props.disabled"
            @click="onContinue"
            append-class="whitespace-nowrap grow max-sm:px-2"
          >
            {{ useTranslation("Checkout-continueToPayment", "Ga verder naar betaling") }}
          </TsButton>
        </div>
      </TsDrawer>
    </Teleport>

    <div class="flex gap-2.5 items-center justify-between px-4 mt-3">
      <TsTypography append-class="leading-[18px] mb-0" variant="h3">
        {{ props.orderTotal }} <br />
        <span class="text-sm text-natural-grey">
          Excl. {{useTranslation('vat' , 'BTW')}} {{ props.totalExcVat }}</span
        >
      </TsTypography>
      <TsButton
        :disabled="props.disabled"
        @click="onContinue"
        append-class="whitespace-nowrap grow max-sm:px-2"
      >
        {{ useTranslation("Checkout-continueToPayment", "Ga verder naar betaling") }}
      </TsButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

const TsDrawer = defineAsyncComponent(
    () => import('~/components/organisms/TsDrawer.vue')
);

const TsCardOrderSummary = defineAsyncComponent(
    () => import('~/components/organisms/TsCardOrderSummary.vue')
);

const order_summary_drawer_visible = ref(false);

const emit = defineEmits(["continue"]);

type Props = {
  totalProducts?: number;
  subTotal?: string;
  totalVat?: string;
  orderTotal?: string;
  totalExcVat?: string;
  shippingCost?: number;
  isFreeShip?: boolean;
  loading?: boolean;
  disabled?: boolean;
  dataTestid: string;
};
const props = withDefaults(defineProps<Props>(), {
  orderTotal: "€ 00,00",
  subTotal: "€ 00,00",
  totalExcVat: "€ 00,00",
  totalVat: "€ 00,00",
  shippingCost: 0,
});

function onContinue() {
  order_summary_drawer_visible.value = false;
  emit("continue");
}
</script>
